module.exports = __webpack_public_path__ + "img/UTSAND.3559cd6f.png";